import React from "react";
import { useNavigate } from "react-router-dom";
import { useLaunchParams } from "@telegram-apps/sdk-react";
import { Bell } from "lucide-react";
import { useUnreadNotifications } from "@/hooks/useNotifications";

/** Bell that opens Notifications, with the unread count. */
export const NotificationsBell: React.FC<{ size?: "sm" | "md" }> = ({ size = "md" }) => {
  const navigate = useNavigate();
  const userId = useLaunchParams().initData?.user?.id?.toString() || "";
  const { data: unread = 0 } = useUnreadNotifications(userId);
  return (
    <button
      type="button"
      aria-label={unread ? `Notifications, ${unread} unread` : "Notifications"}
      onClick={() => navigate("/notifications")}
      className={`glass relative flex items-center justify-center ${size === "sm" ? "!rounded-lg p-2" : "p-2"}`}
    >
      {size === "sm" ? (
        <Bell className="size-4 text-[#d4d4d4]" />
      ) : (
        <img src="/icons/figma/bell.svg" alt="" width={20} height={20} />
      )}
      {unread > 0 && (
        <span className="absolute -right-1 -top-1 flex h-3.5 min-w-3.5 items-center justify-center rounded-full bg-[#ef4444] px-0.5 text-[10px] font-bold leading-none text-white">
          {unread > 99 ? "99+" : unread}
        </span>
      )}
    </button>
  );
};
